import React from "react";

function TitleSupportDashboard(props) {
  return (
    <div
      style={{
        marginRight: "0px",
      }}
    >
      <div style={{ width: props.width }}>
        <div
          style={{
            fontSize: "14px",
            paddingBottom: "3px",
            fontWeight: "700",
            textAlign: "center",
            backgroundColor: props.colorbg,
            // borderRight: "1px solid black",
            paddingLeft: "0px",
          }}
        >
          {props.title}
        </div>
      </div>
    </div>
  );
}

export default TitleSupportDashboard;
